import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

import { LanguageService, SupportedLang } from '../core/language.service';

@Component({
  selector: 'mc-language-selector',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoModule],
  template: `
    <div class="flex items-center gap-3">
      <label
        for="lang-select"
        class="text-xs font-semibold uppercase tracking-widest text-neutral-400"
      >
        {{ 'language.select' | transloco }}
      </label>
      <select
        id="lang-select"
        class="rounded border border-neutral-600 bg-neutral-900 px-2 py-1 text-sm font-medium text-white focus:outline-none focus:ring-2 focus:ring-brand-primary"
        [value]="languageService.currentLang()"
        (change)="onLangChange($event)"
        [attr.aria-label]="'language.select' | transloco"
      >
        @for (lang of languageService.supportedLangs; track lang) {
          <option [value]="lang">{{ 'language.' + lang | transloco }}</option>
        }
      </select>
    </div>
  `,
})
export class LanguageSelector {
  protected readonly languageService = inject(LanguageService);

  protected onLangChange(event: Event): void {
    const lang = (event.target as HTMLSelectElement).value as SupportedLang;
    this.languageService.setLang(lang);
  }
}
